module.exports = __webpack_public_path__ + "img/conimg2-01.a44a30bb.png";